import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "sybil_sigil_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Outer Veil
export const joinWaitlist = (data) => client.post("/waitlist", data).then((r) => r.data);
export const drawArchetype = (data) => client.post("/oracle/draw", data).then((r) => r.data);

// The Gate / Sanctum
export const applyForAudience = (data) => client.post("/audience/apply", data).then((r) => r.data);
export const verifySigil = (sigil) => client.post("/gate/verify", { sigil }).then((r) => r.data);
export const fetchMe = () => client.get("/sanctum/me").then((r) => r.data);
export const fetchReadings = () => client.get("/sanctum/readings").then((r) => r.data);
export const sealOath = () => client.post("/oath/seal").then((r) => r.data);

// The Celestial Council
export const castChart = (data) => client.post("/sanctum/chart", data).then((r) => r.data);
export const fetchChart = () => client.get("/sanctum/chart").then((r) => r.data);
export const fetchCelestial = () => client.get("/sanctum/celestial").then((r) => r.data);
export const fetchFortune = (refresh = false) =>
  client.post(`/sanctum/fortune?refresh=${refresh}`).then((r) => r.data);
export const fetchWisdom = (refresh = false) =>
  client.get(`/sanctum/wisdom?refresh=${refresh}`).then((r) => r.data);
export const expandTradition = (data) =>
  client.post("/sanctum/traditions/expand", data).then((r) => r.data);

// Lunar rituals & Ancestor Altar
export const fetchLunar = () => client.get("/sanctum/lunar").then((r) => r.data);
export const fetchLunarRitual = (refresh = false) =>
  client.post(`/sanctum/lunar/ritual?refresh=${refresh}`).then((r) => r.data);
export const fetchAncestors = () => client.get("/sanctum/ancestors").then((r) => r.data);
export const addAncestor = (data) => client.post("/sanctum/ancestors", data).then((r) => r.data);
export const ancestorVoice = (id) =>
  client.post(`/sanctum/ancestors/${id}/voice`).then((r) => r.data);
export const deleteAncestor = (id) =>
  client.delete(`/sanctum/ancestors/${id}`).then((r) => r.data);

// Council Circles (Matriarch tier)
export const fetchCircle = () => client.get("/sanctum/circle").then((r) => r.data);
export const postCircleSignal = (data) =>
  client.post("/sanctum/circle/signal", data).then((r) => r.data);
export const fetchCircleMessages = (type) =>
  client.get(`/sanctum/circle/${type}/messages`).then((r) => r.data);
export const postCircleMessage = (type, text) =>
  client.post(`/sanctum/circle/${type}/messages`, { text }).then((r) => r.data);

// Ritual Journal (private lunar diary)
export const fetchJournal = () => client.get("/sanctum/journal").then((r) => r.data);
export const addJournal = (data) => client.post("/sanctum/journal", data).then((r) => r.data);

// The Ecosystem — tier-gated capital chambers
export const castScrying = (focus) =>
  client.post("/sanctum/scrying", { focus }).then((r) => r.data);
export const requestOracleSession = (data) =>
  client.post("/sanctum/oracle-sessions", data).then((r) => r.data);
export const fetchOracleSessions = () =>
  client.get("/sanctum/oracle-sessions").then((r) => r.data);

// The Codex of Ruled Time — cyclical planner
export const fetchLunations = () => client.get("/sanctum/lunations").then((r) => r.data);
export const fetchDeployments = () => client.get("/sanctum/deployments").then((r) => r.data);
export const addDeployment = (data) => client.post("/sanctum/deployments", data).then((r) => r.data);
export const deleteDeployment = (id) =>
  client.delete(`/sanctum/deployments/${id}`).then((r) => r.data);

// The Mysteries — society events
export const fetchEvents = () => client.get("/sanctum/events").then((r) => r.data);
export const rsvpEvent = (id) => client.post(`/sanctum/events/${id}/rsvp`).then((r) => r.data);

// Ascension — mint a unique Sigil for the next tier
export const ascend = () => client.post("/sanctum/ascend").then((r) => r.data);
